import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useViewMode } from '../../context/ViewModeContext';
import { Home, FileText, User, Monitor } from 'lucide-react';
import { BetaBanner } from '../BetaBanner';

export const MobileLayout = () => {
  const { user, logout } = useAuth();
  const { switchToDesktop } = useViewMode();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleSwitchToDesktop = () => {
    switchToDesktop();
    navigate('/app/dashboard');
  };

  const navItems = [
    { path: '/m', icon: Home, label: 'Home' },
    { path: '/m/bollettini', icon: FileText, label: 'Bollettini' },
    { path: '/m/profilo', icon: User, label: 'Profilo' },
  ];

  const isActive = (path) => {
    if (path === '/m') return location.pathname === '/m';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="mobile-layout">
      <BetaBanner />
      {/* Header */}
      <header className="bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between sticky top-0 z-50">
        <h1 className="text-lg font-bold text-slate-900">BollettinoX</h1>
        <button
          onClick={handleSwitchToDesktop}
          className="p-2 text-slate-400 hover:text-slate-600"
          title="Versione desktop"
          data-testid="switch-to-desktop-btn"
        >
          <Monitor className="h-5 w-5" />
        </button>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 px-2 py-1 z-50 safe-area-bottom" data-testid="mobile-bottom-nav">
        <div className="flex items-center justify-around max-w-md mx-auto">
          {navItems.map(({ path, icon: Icon, label }) => (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center gap-0.5 px-3 py-2 rounded-lg transition-colors min-w-[64px] ${
                isActive(path)
                  ? 'text-blue-600'
                  : 'text-slate-400 hover:text-slate-600'
              }`}
              data-testid={`mobile-nav-${label.toLowerCase()}`}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[10px] font-medium">{label}</span>
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
};
